import * as Sentry from '@sentry/browser';
import { renderToStaticMarkup } from 'react-dom/server';
import { onMissingTranslationFunction } from 'react-localize-redux';
import en from '../languages/en';

const onMissingTranslation: onMissingTranslationFunction = ({
  translationId,
  languageCode,
  defaultTranslation,
}) => {
  if (process.env.NODE_ENV === 'development') {
    return `missing translation key: ${translationId} for ${languageCode}`;
  }
  if (process.env.NODE_ENV === 'production') {
    Sentry.captureEvent({
      message: `missing translation key: ${translationId} for ${languageCode}`,
      level: Sentry.Severity.Error,
      extra: {
        translationId,
        languageCode,
      },
    });
  }
  return defaultTranslation;
};

export const getLanguage = (navigator: any): string => {
  if (!navigator) return 'en';
  const languageCode = navigator.languages
    ? navigator.languages[0]
    : navigator.language || navigator.userLanguage;
  if (!languageCode) return 'en';
  return languageCode.split('-')[0];
};

export const SUPPORTED_LANGUAGES = ['en', 'fr'];

// getActiveLanguage returns the given language if supported, otherwise 'en'.
export const getActiveLanguage = (language: string): string => {
  return SUPPORTED_LANGUAGES.indexOf(language) !== -1 ? language : 'en';
};

// getEnabledLanguages returns the languages a visitor may see for this collection, always including English.
// SUPPORTED_LANGUAGES is a deliberate manual cap — languages may carry more codes as language support expands.
export const getEnabledLanguages = (languages: string[] = []): string[] => {
  const enabled = new Set(['en', ...languages].filter(l => SUPPORTED_LANGUAGES.includes(l)));
  return Array.from(enabled);
};

export const initializePayload = () => {
  return {
    languages: [{ name: 'English', code: 'en' }, { name: 'French', code: 'fr' }],
    translation: en,
    options: {
      // 'en' must stay the fallback baseline for react-localize-redux's defaultLanguage; the displayed language switches separately via setActiveLanguage.
      defaultLanguage: 'en',
      renderToStaticMarkup,
      renderInnerHtml: true,
      ignoreTranslateChildren: true,
      onMissingTranslation,
    },
  };
};
